import React from 'react'
import Select from 'react-select'
import { XIcon } from '@heroicons/react/outline'

const TabItem = ({ openTab, setOpenTab, selectedClient, clients, setSelectedClient, index, removeTab }) => {
    return (
        <div className={"text-xs font-bold uppercase rounded block leading-normal flex"}>
            <Select
                className='w-60'
                placeholder={'Type to search'}
                onChange={(item) => setSelectedClient(item, index)}
                options={clients}
                classNamePrefix='select'
                value={selectedClient ? selectedClient : 'Type to search'}
            />
            <button type="button" className="rounded-full  w-5 h-5 p-1  bg-red-500 ml-3 text-white" onClick={() => { removeTab(index) }}><XIcon /></button>
        </div>
    )
}

export default TabItem
